module.exports = __webpack_public_path__ + "static/Frame.f1bafbec.svg";